import { render, staticRenderFns } from "./talent-level.view.vue?vue&type=template&id=4bd12900&scoped=true&"
import script from "./talent-level.view.vue?vue&type=script&lang=ts&"
export * from "./talent-level.view.vue?vue&type=script&lang=ts&"
import style0 from "./talent-level.view.vue?vue&type=style&index=0&id=4bd12900&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd12900",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
